import script from "./ToastCom.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastCom.vue?vue&type=script&setup=true&lang=js"

import "./ToastCom.vue?vue&type=style&index=0&id=b3e99ad0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3e99ad0"]])

export default __exports__